<template>
  <div></div>
</template>

<script>
import axios from "@/axios.js";

export default {
  data() {
    return {};
  },
  created() {
    this.$vs.loading();

    const accessToken = this.$route.query.token;
    const userId = this.$route.query.userId;
    const isAddToBoard = this.$route.query.addToBoard;
    const redirect = this.$route.query.redirect;

    if (!accessToken || !userId) return;

    axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    localStorage.setItem("accessToken", accessToken);

    this.$store.commit("auth/SET_ACCESS_TOKEN", accessToken);
    this.$store.commit("auth/SET_LOGGEDIN_STATE", true);

    this.$store.dispatch("users/fetchUser", userId).then((res) => {
      localStorage.setItem(
        "user",
        JSON.stringify({
          _id: res.data._id,
          email: res.data.email,
        })
      );
      this.$store.commit("auth/SET_USER", res.data);

      this.$store.commit(
        "editor/SET_PERSONAL_EVALUATION",
        res.data.personalEvaluation[0]
      );
      this.$store.commit("editor/SET_CAREER_HISTORY", res.data.careerHistory);
      this.$store.commit(
        "editor/SET_EDUCATIONAL_QUALIFICATIONS",
        res.data.educationalQualifications
      );
      this.$store.commit("editor/SET_PROJECTS", res.data.projects);
      this.$store.commit(
        "editor/SET_EXTRA_CURRICULAR",
        res.data.extraCurricular[0]
      );
      this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
      let validaTionData = JSON.parse(
        localStorage.getItem("attendanceValidationData")
      );

      if (isAddToBoard !== "false" && !isAddToBoard && isAddToBoard !== null) {
        this.$store
          .dispatch("boards/fetchBoardBySlug", isAddToBoard)
          .then((res) => {
            let boardId = res.data[0]._id;
            window.location.href = `/user/board/${boardId}`;
          })
          .catch(() => {
            window.location.href = "/user/dashboard";
          });
      } else if (validaTionData && Object.keys(validaTionData).length > 0) {
        window.location.href = `/validation-attendance-completed/process?itemId=${validaTionData.itemId}&orgId=${validaTionData.orgId}&token=${validaTionData.token}`;
      } else if (redirect) {
        window.location.href = redirect;
      } else {
        window.location.href = "/user/dashboard";
      }
    });
  },
};
</script>
